import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import './productParams.scss'
import { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import { useAppSelector } from "../../services/hooks";
import { useTranslation } from "react-i18next";

export default function ProductParams() {
    const { t } = useTranslation('productPage')
    const [isExpanded, setIsExpanded] = useState(false)
    const [height, setHeight] = useState("250px")
    const descriptionRef = useRef<HTMLDivElement>(null);
    const scrollRef = useRef<HTMLDivElement>(null)

    const params = useAppSelector((state) => state.product.data.params)

    const showParams = (max: number = params.length) => {
        return params.map((param, index) => {
            if (index < max) return (
                <Row key={index} as={"label"} htmlFor={`toCompareOrSomethingElse-${index}`} className="p-2 border-1 border-bottom  border-secondary  border-opacity-25 parametrsZebra ">
                    <Col xs={6}>
                        {param.name}
                    </Col>
                    <Col xs={4} className="text-end">
                        <strong>{param.value}</strong>
                    </Col>
                    <Col xs={2} className="text-start">
                        {param.unit}
                    </Col>
                </Row>
            )
        })
    }

    const scrollToDiv = () => {
        if (!scrollRef.current) return
        const element = scrollRef.current;
        const topPosition = element.getBoundingClientRect().top + window.scrollY;

        window.scrollTo({
            top: topPosition - 140,
            behavior: "smooth",
        });
    };

    useEffect(() => {
        if (!descriptionRef.current) return
        if (isExpanded) {
            setHeight(`${descriptionRef.current.scrollHeight}px`); // Pełna wysokość
        } else {
            setHeight("250px"); // Zwinięta wysokość
        }
    }, [isExpanded]);

    if (params) return (<>
        <Col xs={{ span: 12, order: 2 }} lg={{ span: 12, order: 2 }} xl={{ span: 12, order: 1 }} className="position-relative pt-3">
            <Row className="gx-0">
                <Col xs={12} ref={scrollRef} className="p-2 mx-0 mb-4 border-4 border-bottom border-secondary border-opacity-25">
                    <h2>{t('params')}</h2>
                </Col>
                <Col xs={12} className={!isExpanded && params.length > 6 ? "collapse-container-params-list blurBottomContent" : "collapse-container-params-list"} ref={descriptionRef} style={{ maxHeight: height }}>
                    {showParams()}
                </Col>
            </Row>
        </Col>
        <Row>
            {params.length > 6 &&
                <Col xs={12} className="text-center">
                    <Button onClick={() => { setIsExpanded(!isExpanded); scrollToDiv() }} variant="success" className="mt-2 bi bi-arrows-expand fw-bold">
                        {isExpanded
                            ? <span className="ps-2">{t('collapse.less')}</span>
                            : <span className="ps-2">{t('collapse.more')}</span>
                        }
                    </Button>
                </Col>
            }
        </Row>
    </>
    )
}